<template>
  <div class="container">
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <h1 class="section-header text-left">My Organizations</h1>
    <div class="row">
      <div class="col-lg-4 text-left">
        <h1>Join Existing Organization</h1>
        <span>Your organization may already be in our database. Search below to join your organization.</span>
        <div class="row justify-content-md-center">
          <div class="col-lg-12 mt-3">
            <b-input-group>
              <b-input id="search" v-model="search" placeholder="Search" />
              <b-input-group-append>
                <b-button name="search" class="btn btn-secondary search" @click="searchForOrgs()">Search</b-button>
                <b-button v-if="userHasSearched" name="search" class="ml-3" @click="clearSearch()">Clear Search</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="col-lg-4 text-left">
        <h1>Create New Organizaton</h1>
        <span>If you can't find your organization, you may also add it. Please don't add duplicate
          organizations!</span><br />
        <router-link :to="{ name: 'org create' }" class="">
          <b-button class="mt-3">Create</b-button>
        </router-link>
      </div>
      <div v-if="this.$store.state.auth.mUser.role === 'partner'" class="col-lg-4 text-left">
        <h1>Request DMO Access</h1>
        <span>Are you a member of an affiliated Destination Marketing Organization (DMO)? Request DMO Partner access to be
          able to submit suggestions to city
          pages.</span><br />
        <b-button class="btn btn-dmo mt-3" :disabled="isRequestAccessButtonDisabled" @click="openModal()">{{
          requestAccessButtonText }}</b-button>
      </div>
    </div>
    <div class="row text-left mt-3" v-if="$store.state.organizations.searchList.length > 0 && !userClearedSearch">
      <div class="col-lg-3" v-for="org in $store.state.organizations.searchList" :key="org._id">
        <b-card v-match-heights="{ el: ['.org-card'] }" class="mb-3 org-card" header="Organization">
          <b-alert show variant="success" v-if="requestPending(org._id)" class="in-review">In Review</b-alert>
          <b-button v-else-if="requestAccepted(org._id)" class="btn join-btn"
            @click="leaveOrganization(org._id)">Leave</b-button>
          <b-button v-else class="btn join-btn" :disabled="isLoadingOrgIds.includes(org._id)" @click="joinRequest(org._id)">Join</b-button>
          <router-link :to="{ name: 'org detail', params: { orgId: org._id } }" class="button"><b>{{ org.name
          }}</b></router-link>
          <br />
          {{ org.address1 }} <br />
          {{ org.city }}, AL {{ org.zip }} <br />
          {{ org.telephone | telephoneNumber }} <br />
        </b-card>
      </div>
    </div>
    <div v-else-if="$store.state.organizations.searchList.length == 0 && userHasSearched">
      <b-alert show variant="info" class="mt-3">No Results Found</b-alert>
    </div>
    <div class="text-left">
      <div class="row">
        <div class="col-lg-12 mt-5">
          <b-card>
            <h1>Your Organizations</h1>
            <div v-if="sortingField">
              Sorting By: <b>{{ sortField }}</b>, Sort Direction: <b>{{ sortingOrder === 'asc' ? 'Ascending' :
                'Descending' }}</b>
            </div>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th @click="sort('name')">Name <font-awesome-icon icon="sort" /></th>
                  <th @click="sort('city')">City <font-awesome-icon icon="sort" /></th>
                  <th class="count">Event Count</th>
                  <th class="count">Location Count</th>
                  <th class="count">Member Count</th>
                  <th class="count">Join Request Count</th>
                  <th>Leave</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="org in userOrgs" :key="org._id">
                  <td>
                    <router-link :to="{ name: 'org detail', params: { orgId: org._id } }">{{ org.name }}</router-link>
                  </td>
                  <td>{{ org.city }}</td>
                  <td class="count">{{ org.events ? org.events.length : 0 }}</td>
                  <td class="count">{{ org.locations ? org.locations.length : 0 }}</td>
                  <td class="count">{{ org.users ? org.users.length : 0 }}</td>
                  <td class="count">
                    <template v-if="org.joinRequestCount > 0">
                      <router-link :to="{ name: 'org detail', params: { orgId: org._id } }">{{ org.joinRequestCount
                      }}</router-link>
                    </template>
                    <template v-else>
                      {{ org.joinRequestCount }}
                    </template>
                  </td>
                  <b-button size="sm" class="mt-1 mb-1" @click="leaveOrganization(org._id)">Leave</b-button>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div>
      </div>
    </div>
    <div class="text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-12 mt-5">
          <b-card>
            <h1>Your Organization Join Requests</h1>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th @click="sort('name')">Name <font-awesome-icon icon="sort" /></th>
                  <th @click="sort('city')">City <font-awesome-icon icon="sort" /></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="req in joinRequests" :key="req._id">
                  <td>
                    <router-link :to="{ name: 'org detail', params: { orgId: req.organizations[0]._id } }">{{
                      req.organizations[0].name }}</router-link>
                  </td>
                  <td>{{ req.organizations[0].city }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showRequestDmoModal">
      <div class="modal-content">
        <p>Briefly describe your relationship to a DMO. (Required)</p>
        <textarea v-model="dmoRequestJustification"></textarea>
        <p v-if="showModalErrors" class="modal-error">Please enter a message.</p>
        <div class="modal-actions">
          <b-button name="modal-confirm" :disabled="isLoading" class="btn btn-dmo" @click="requestDmoAccess()">{{
            requestAccessButtonText }}</b-button>
          <b-button name="modal-cancel" class="btn btn-white" @click="closeModal()">Cancel</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      search: '',
      filter: '',
      sortField: '',
      sortingField: '',
      sortingOrder: 'asc',
      displayMap: {
        name: 'Name',
        city: 'City',
      },
      userOrgs: [],

      joinRequests: [],
      userHasSearched: false,
      userClearedSearch: false,
      showRequestDmoModal: false,
      showModalErrors: false,
      dmoRequestJustification: '',
      requestAccessButtonText: 'Request Access',
      isRequestAccessButtonDisabled: false,
      isLoadingOrgIds: []
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.checkIfDmoRequested();
      await this.loadData();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    this.clearSearch();
    this.$store.dispatch('organizations/resetSearchList');
  },
  methods: {
    async checkIfDmoRequested() {
      if (this.$store.state.auth.mUser.role === 'partner') {
        const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/roles/requests?role=dmo&userId=${this.$store.state.auth.mUser._id}&status=Requested`);

        if (response.data.success && response.data.requests.length) {
          this.requestAccessButtonText = 'Access Requested';
          this.isRequestAccessButtonDisabled = true;
        }
      }
    },
    async requestDmoAccess() {
      this.showModalErrors = false;
      if (!this.dmoRequestJustification) {
        this.showModalErrors = true;
        return;
      }

      this.isLoading = true;
      this.requestAccessButtonText = 'Requesting...';
      const response = await axios.post(`${process.env.VUE_APP_API_ROOT}/roles/request`, {
        role: 'dmo',
        userId: this.$store.state.auth.mUser._id,
        justification: this.dmoRequestJustification,
      });

      if (response.data.success) {
        this.$bvToast.toast("Request sent. We'll review soon.", { title: 'Success', autoHideDelay: 5000, appendToast: true });
        this.requestAccessButtonText = 'Access Requested';
        this.isRequestAccessButtonDisabled = true;
        this.closeModal();
      } else {
        this.$bvToast.toast('Something went wrong. Please contact us at info@alabama.travel.', { title: 'Error', autoHideDelay: 5000, appendToast: true });
        this.requestAccessButtonText = 'Request Access';
      }

      this.isLoading = false;
    },
    openModal() {
      this.showRequestDmoModal = true;
    },
    closeModal() {
      this.showRequestDmoModal = false;
    },
    async clearSearch() {
      this.search = '';
      this.userHasSearched = false;
      this.userClearedSearch = true;
    },
    async loadData() {
      const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/getOrgsForUser/${this.$store.state.auth.mUser._id}`);
      this.userOrgs = response.data.userOrganizations;
      this.joinRequests = response.data.userJoinRequests;
      this.isLoadingOrgIds = [];
    },
    compareValues(key, order = 'asc') {
      return function innerSort(a, b) {
        // eslint-disable-next-line
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
        const comparison = a[key].localeCompare(b[key]);

        return order === 'desc' ? comparison * -1 : comparison;
      };
    },
    sort(field) {
      if (this.sortingField === field) {
        this.sortingOrder = this.sortingOrder === 'asc' ? 'desc' : 'asc';
      }
      this.sortingField = field;
      this.userOrgs.sort(this.compareValues(this.sortingField, this.sortingOrder));
      this.sortField = this.displayMap[this.sortingField];
    },
    searchList() {
      this.$store.dispatch('organizations/setFilter', this.filter);
    },
    async searchForOrgs() {
      await this.$store.dispatch('organizations/searchOrgsToJoin', this.search);
      this.userClearedSearch = false;
      this.userHasSearched = true;
    },
    async joinRequest(orgId) {
      this.isLoadingOrgIds.push(orgId);
      await this.$store.dispatch('organizations/requestToJoinOrg', orgId);

      if (this.$store.state.auth.mUser.membership_requests.find((mr) => mr.organization_id === orgId)) {
        this.$bvToast.toast('Request successfully received', {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: false,
        });
      } else {
        this.$bvToast.toast('Something went wrong in this request', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: false,
        });
      }

      await this.loadData();
    },
    getUserMembershipRequestForOrg(orgId) {
      return this.userOrgs.find((mr) => mr.organization_id === orgId);
    },
    requestPending(orgId) {
      return this.joinRequests.find((mr) => mr.organization_id === orgId);
    },
    requestAccepted(orgId) {
      return this.userOrgs.find((mr) => mr._id === orgId);
    },
    async leaveOrganization(orgId) {
      const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/removeUserFromOrg/${this.$store.state.auth.mUser._id}/${orgId}`;
      const response = await axios.get(url);
      if (response.status === 200) {
        this.$bvToast.toast('You have successfully left this organization.', {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }

      await this.loadData();
    },
  },
};
</script>

<style scoped>
div>.btn-secondary.search {
  border-radius: 0px var(--rounded) var(--rounded)0px;
}

.card {
  border: none;
}

.card-body h1 {
  margin: 0px 0 10px 0;
}

.join-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

.in-review {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0px 5px;
}

.section-header {
  font-size: 2.9rem;
  margin-bottom: 0;
}

.btn-white {
  border: none;
}

textarea {
  border-color: #919191;
  resize: none;
  height: 10rem;
  padding: 12px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  color: black;
}

.modal-content {
  text-align: left;
  background-color: #fefefe;
  margin: 15% auto;
  padding: 32px;
  border: 1px solid #888;
  border-radius: var(--rounded-lg);
  width: 80%;
  font-weight: 300;
}

.modal-actions {
  margin-top: 2rem;
  display: flex;
  gap: 12px;
}

.modal-error {
  margin-top: 0.5rem;
  margin-bottom: 0;
  color: black;
  opacity: 0.85;
  font-weight: bold;
  font-size: 0.85rem;
}</style>
